import { render, staticRenderFns } from "./Stamp.vue?vue&type=template&id=fd1e59b0&"
var script = {}
import style0 from "./Stamp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports